import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { IoArrowForwardOutline } from "react-icons/io5";
import { Input, Button, Card } from "@nextui-org/react";
import { EyeFilledIcon } from "../../../../common/assets/jsx/EyeFilledIcon.js";
import { EyeSlashFilledIcon } from "../../../../common/assets/jsx/EyeSlashFilledIcon.js";
import { MailIcon } from "../../../../common/assets/jsx/MailIcon.js";
import { toast } from "sonner";

const Login = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [userFormData, setUserFormData] = useState({ email: "", password: "" });
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const validateForm = () => {
    const { email, password } = userFormData;
    const newErrors = {};

    if (!email) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      newErrors.email = "Email address is invalid";
    }

    if (!password) {
      newErrors.password = "Password is required";
    } else if (password.length < 6) {
      newErrors.password = "Password must be at least 6 characters";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handelLogin = async (data) => {
    try {
      if (
        data.email === "gaurabsunar@gmail.com" &&
        data.password === "gaurab"
      ) {
        toast.success("User logged in successfully");
        localStorage.setItem("email", data.email);
        localStorage.setItem("userid", 101110101);
        navigate("/dashboard");
      } else {
        toast.error("Invalid email or password");
      }
      // const response = await dispatch(loginUser(data));
      // if (response.error) {
      //   if (
      //     response.error.code &&
      //     response.error.code.includes("ERR_BAD_REQUEST")
      //   ) {
      //     toast.error("Invalid email or password");
      //   }
      //   return;
      // }
      // if (response.payload.token) {
      //   localStorage.setItem("token", JSON.stringify(response.payload.token));
      //   navigate("/");
      //   window.location.reload();
      //   toast.success("User logged in successfully.");
      // } else if (response.payload?.error) {
      //   toast.error(response.payload.error);
      // }
    } catch (error) {
      toast.error("Some error occurred, try again later");
    }
  };

  const formInputFieldChange = (e) => {
    setUserFormData({ ...userFormData, [e.target.name]: e.target.value });
  };

  const formsubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      handelLogin(userFormData);
    }
  };

  const toggleVisibility = () => setIsVisible(!isVisible);

  return (
    <div className="min-h-[100vh] flex justify-center items-center">
      <div className="min-h-[200px] w-[400px] my-20 rounded ">
        <form onSubmit={formsubmit}>
          <Card
            radius="none"
            className="rounded-sm flex gap-5 flex-col p-8 font-poppins"
          >
            <div className="flex justify-between items-center">
              <h3 className="text-black font-semibold tracking-wider text-2xl font-Orbitron">
                Sign In
              </h3>
              <h2 className="text-black font-semibold tracking-wider text-2xl font-Orbitron">
                QPixelbot
              </h2>
              {/* <img src={Logo} height={40} width={130} alt="logo" /> */}
            </div>
            <h3 className="text-black/80 text-sm">Welcome back !!!</h3>
            <div className="flex gap-1 -mt-1 flex-col">
              <label
                htmlFor="email"
                className="text-sm text-black cursor-pointer"
              >
                Email
              </label>
              <Input
                size="sm"
                variant="faded"
                radius="sm"
                label="Email"
                type="text"
                name="email"
                value={userFormData.email}
                onChange={formInputFieldChange}
                endContent={
                  <MailIcon className="text-2xl mb-1 text-default-400 pointer-events-none flex-shrink-0" />
                }
              />
              {errors?.email?.length > 1 && (
                <div className="text-xs -mb-2 font-poppins text-red-700 ml-2">
                  {errors.email}
                </div>
              )}
            </div>
            <div className="flex gap-1 flex-col">
              <div className="flex justify-between">
                <label
                  htmlFor="password"
                  className="text-sm text-black cursor-pointer"
                >
                  Password
                </label>
              </div>
              <Input
                size="sm"
                variant="faded"
                label="Password"
                radius="sm"
                name="password"
                value={userFormData.password}
                onChange={formInputFieldChange}
                endContent={
                  <button
                    className="focus:outline-none"
                    type="button"
                    onClick={toggleVisibility}
                  >
                    {isVisible ? (
                      <EyeSlashFilledIcon className="text-2xl mb-1 text-default-400 pointer-events-none" />
                    ) : (
                      <EyeFilledIcon className="text-2xl mb-1 text-default-400 pointer-events-none" />
                    )}
                  </button>
                }
                type={isVisible ? "text" : "password"}
                className="w-full"
              />
              {errors?.password?.length > 1 && (
                <div className="text-xs -mb-2 font-poppins text-red-700 ml-2">
                  {errors.password}
                </div>
              )}
            </div>
            <div className="flex gap-2 justify-end">
              <Button
                fullWidth
                color="primary"
                radius="none"
                className="rounded-sm"
                type="submit"
                endContent={<IoArrowForwardOutline />}
              >
                Login
              </Button>
            </div>
            <div>
              <p className="text-xs text-black/80 tracking-wider  pb-2">
                Don't have an account?{" "}
                <Link
                  to={"/register"}
                  className="text-blue-400 hover:text-blue-500 duration-150"
                >
                  Register
                </Link>
              </p>
            </div>
          </Card>
        </form>
      </div>
    </div>
  );
};

export default Login;
